import React from "react";
import "./App.css";
import Footer from "./common/components/footer/footer";
import Header from "./common/components/header/header";
import Landing from "./common/components/landing/landing";
import LandingMobile from "./common/components/landing/landingMobile";
import Home from "./features/home/home";
import Services from "./features/services/services";
import HQI from "./features/hqi/hqi";

function App() {
  const isMobileDevice = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  let Component;
  switch (window.location.pathname) {
    case "/":
      Component = Home;
      break;
    case "/services":
      Component = Services;
      break;
    case "/hqi":
      Component = HQI;
      break;
    default:
      Component = Home;
      break;
  }

  return (
    <div>
      <div className="container-fluid">
        <Header path={window.location.pathname}></Header>
      </div>
      {window.location.pathname === "/" && (
        <div id="landing-carousel">
          {isMobileDevice() ? <LandingMobile /> : <Landing />}
        </div>
      )}
      <div id="content" className="container-fluid">
        <Component></Component>
      </div>
      <div className="container-fluid">
        <Footer></Footer>
      </div>
    </div>
  );
}

export default App;